import React, { useState } from "react";
import { Button, Modal } from "antd";
import { useIntl } from "react-intl";
import { SubscriptionInfo, } from "services/rest/subscription";
import { DateUtils } from "services/utils/DateUtils";
import { StoreTable } from "toolkit/table/StoreTable";
import { ColumnsType } from "antd/es/table";
import { LocalDate } from "types/general";

export type SubscriptionModalProps = {
  visible: boolean;
  onOk: (row: SubscriptionRow) => void;
  onCancel: () => void;
  loading?: boolean,
  activeSubscriptions?: SubscriptionInfo[];
};

export type SubscriptionRow = {
  id: string;
  startDate: LocalDate;
  expireOn: LocalDate;
  plan: string;
  keysCount: string;
  nextPayment: LocalDate;
};

export function SubscriptionModal(props: SubscriptionModalProps) {
  const { visible, activeSubscriptions, loading, onOk, onCancel } = props;
  const intl = useIntl();
  const [subscription, setSubscription] = useState<SubscriptionRow>(Object);

  const columns: ColumnsType = [
    {
      title: intl.formatMessage({ id: "jmix-store.license-keys-to-delete-modal.column.started-on" }),
      dataIndex: "startDate",
      key: "startDate",
    },
    {
      title: intl.formatMessage({ id: "jmix-store.license-keys-to-delete-modal.column.expire-on" }),
      dataIndex: "expireOn",
      key: "expireOn",
    },
    {
      title: intl.formatMessage({ id: "jmix-store.subscription-configure.plan" }),
      dataIndex: "plan",
      key: "plan",
    },
    {
      title: intl.formatMessage({ id: "jmix-store.subscription-modal.column.keys" }),
      dataIndex: "keysCount",
      key: "keysCount",
    },
    {
      title: intl.formatMessage({ id: "jmix-store.subscription-item.next-payment-label" }),
      dataIndex: "nextPayment",
      key: "nextPayment",
    },
  ];

  const dataSource = activeSubscriptions?.map(
    (subscription) => {
      return {
        key: subscription.id,
        id: subscription.id,
        startDate: DateUtils.getFormatDate(subscription.startDate),
        expireOn: DateUtils.getFormatDate(subscription.nextPayment.date),
        plan: subscription.tariff.name,
        keysCount: subscription.userCount,
        nextPayment: DateUtils.getFormatDate(
          subscription.nextPayment.date
        ),
      };
    }
  );

  return (
    <Modal
      centered
      width="800px"
      title={intl.formatMessage({ id: "jmix-store.subscription-modal.title" })}
      open={visible}
      onOk={() => onOk(subscription)}
      onCancel={onCancel}
      okText={intl.formatMessage({ id: "jmix-store.subscription-modal.ok-text" })}
      okButtonProps={{ disabled: subscription.id == undefined }}
    >
      <Button type="link" onClick={onCancel}>
        {intl.formatMessage({ id: "jmix-store.subscription-modal.purchase-new-button" })}
      </Button>
      <StoreTable
        loading={loading}
        rowSelection={{
          type: "radio",
          onChange: (
            selectedRowKeys: React.Key[],
            selectedRows: SubscriptionRow[]
          ) => {
            setSubscription(selectedRows[0]);
          },
        }}
        columns={columns}
        dataSource={dataSource}
      />
    </Modal>
  );
}
